// extracted by mini-css-extract-plugin
export default {"anchorWithStickyNavbar":"anchorWithStickyNavbar_fF9Z","anchorWithHideOnScrollNavbar":"anchorWithHideOnScrollNavbar_Yh18"};